<div class="layout-content">
<form (ngSubmit)="submit()" [formGroup]="siteForm">
  <!-- ROW * -->
  <div class="grid">
		<div [ngClass]="col12Responsive()">
			<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME' | translate }} {{ 'SITE' | translate }}</div>
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'borderInput')">
					<input type="text" pInputText
						[ngClass]="dynamicInputTextWidth()"
						id="site-dialog-input-name"
						formControlName="name"
						autocomplete="name"
						placeholder="{{ 'NAME' | translate }}"
						maxlength="50"
						pAutoFocus
						[autofocus]="true"
					/>
				</div>
			</div>
			<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
		</div>
		<div [ngClass]="col12Responsive()">
			<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.description, 'borderRow')">
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.description, 'label')">{{ 'DESCRIPTION' | translate }}</div>
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.description, 'borderInput')">
					<input type="text" pInputText
						[ngClass]="dynamicInputTextWidth()"
						id="site-dialog-input-description"
						formControlName="description"
						autocomplete="description"
						placeholder="{{ 'DESCRIPTION' | translate }}"
						maxlength="50"
					/>
				</div>
			</div>
			<small *ngIf="showErrorRequiredMessage(this.f.description)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
		</div>
		<div class="col-12" [ngClass]="customPaddingX()">
			<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.timezone, 'borderRow')">
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.timezone, 'label')">{{ 'TIMEZONE' | translate }}</div>
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.timezone, 'borderInput')">
					<p-autoComplete formControlName="timezone" [suggestions]="filteredTimezone"
						[ngClass]="dynamicLongInputTextWidth()"
						[styleClass]="dynamicLongInputTextWidth()"
						inputStyleClass="pl-6 border-noround-right"
						id="site-dialog-input-timezone"
						(completeMethod)="filterTimezone($event)" [dropdown]="true"
						[readonly]="autoInsert"
						[panelStyleClass]="dynamicAutocomplete()" [forceSelection]="true">
					</p-autoComplete>
				</div>
			</div>
			<small *ngIf="showErrorRequiredMessage(this.f.timezone)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			<small *ngIf="autoInsert" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'AUTOCOMPILE_TIMEZONE' | translate }}</small>
		</div>
		<div class="col-12" [ngClass]="customPaddingX()">
			<div class="flex justify-content-between flex-wrap border-bottom-1 border-100" [ngClass]="simpleInputTextLayout('borderRow')">
				<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{ 'COVER_SITE' | translate }}</div>
				<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('borderInput')">
					<!-- TODO: Implement p-fileUpload advanced with three buttons 'CHOOSE', 'UPLOAD', 'CANCEL' -->
					<!-- OR fileUpload npx-image-cropper for crop image user -->
					<p-fileUpload *ngIf="!canDeleteUpload" mode="basic"
						chooseLabel="{{'UPLOAD_IMAGE' | translate }}"
						type="file"
						(onSelect)="handleFileInput($event)"
						styleClass="pr-5 {{dynamicLongInputTextWidth()}}"
						[ngClass]="dynamicLongInputTextWidth()"
						>
					</p-fileUpload>
					<img *ngIf="canDeleteUpload" id="previewImage"
						[src]="imgPreview" class="border-radius-xl mr-2"/>
					<div *ngIf="canDeleteUpload && imgPreview === ''" class="mr-2 text-50">
						<p>{{ 'RELOAD_IMAGE' | translate }}</p>
					</div>
					<button *ngIf="canDeleteUpload" pButton pRipple type="button"
						id="custom-email-permission-upload-cancel"
						icon="pi cm-cancel" class="p-button-danger" size="small"
						(click)="clearLogo()">
					</button>
				</div>
			</div>
		</div>
		<div class="col-12" [ngClass]="customPaddingX()">
			<form [formGroup]="searchControl" class="form-signin text-center">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.location, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.location, 'label')">{{ 'SEARCH_ADDRESS' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.location, 'borderInput')">
						<p-autoComplete formControlName="location" [suggestions]="filteredPlace"
								[ngClass]="dynamicLongInputTextWidth()"
								inputStyleClass="pl-6 border-noround-right {{dynamicLongInputTextWidth()}}"
								[styleClass]="dynamicLongInputTextWidth()"
								[panelStyleClass]="dynamicAutocomplete()"
								id="site-dialog-input-location"
								(completeMethod)="completeMethod($event)" field="description" [dropdown]="true"
								(onSelect)="onSelectMap($event)" [forceSelection]="true"
								[placeholder]="getPlaceholder()">
						</p-autoComplete>
						<!-- <ng-template pTemplate="selectedItem">
							<div class="item" class="flex align-items-center justify-content-center text-center pl-5">
								<div class="flex align-items-center">{{ address }}</div>
							</div>
						</ng-template>
						</p-autoComplete> -->
					</div>
				</div>
				<!-- DOESN'T REQUIRED VALIDATOR -> for enable insert Validators.required on buildForm()-->
				<!-- <small *ngIf="showErrorRequiredMessage(this.f.location)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
			</form>
	  </div>

		<div class="col-12">
		  <div class="flex align-items-center justify-content-center">
				<div id="map"></div>
		  </div>
		</div>

	</div>

	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="submit" pButton pRipple
			label="{{ 'CONFIRM' | translate }}"
			class="p-button-primary text-xl font-normal mt-2 mx-1"
			[ngClass]="dynamicButtonWidth()">
		</button>
		<button type="button" pButton pRipple (click)="closeDialog()"
				label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1"
				[ngClass]="dynamicButtonWidth()">
		</button>
	</div>
  </form>
</div>
